import { FC } from 'react';
import { useField } from 'formik';
import styles from 'components/contactForm/contactForm.module.css';
import { EMPTY_STRING } from 'constants/shared';

interface SingleCheckboxListProps {
    name: string;
    options: { key: string; label: string }[];
    isbooknowform?: boolean;
}

export const SingleCheckboxList: FC<SingleCheckboxListProps> = ({
    name,
    options,
    isbooknowform,
}) => {
    const [field, , helpers] = useField(name);
    const { setValue } = helpers;

    return (
        <div className={styles.checkboxList}>
            {options.map(({ key, label }) => (
                <label key={key} className={styles.checkboxLabel}>
                    <input
                        className={
                            isbooknowform ? styles.customCheckbox : EMPTY_STRING
                        }
                        type="checkbox"
                        name={name}
                        value={label}
                        checked={field.value === label}
                        onChange={() =>
                            setValue(
                                field.value === label ? EMPTY_STRING : label
                            )
                        }
                    />
                    {label}
                </label>
            ))}
        </div>
    );
};
